import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Link, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { deleteDocument } from "../../firebase/firebaseCrud";
import DeleteConfirmModal from "../global/DeleteConfirmModal";
import { ReactComponent as DeleteIcon } from "../../static/svg/bin.svg";

export const MediaCard = ({ id, imgSrc, title, path, price, priceColor }) => {
  const pagepath = useLocation();
  const [show, setShow] = useState(false);
  const [hovered, setHovered] = useState(false);

  const handleDelete = async () => {
    await deleteDocument("product-list", id);
    toast(`Product deleted: ${id}`, { type: "success" });
    setShow(false);
  };

  return (
    <Box sx={{ position: "relative" }}>
      <ToastContainer />

      {/* Image block with hover zoom + overlay CTA */}
      <Box
        component={Link}
        to={path}
        sx={{ display: "block", textDecoration: "none", position: "relative", overflow: "hidden", aspectRatio: "3/4" }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <img
          src={imgSrc}
          alt={title}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            transition: "transform 0.5s ease",
            transform: hovered ? "scale(1.05)" : "scale(1)",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            bgcolor: "rgba(0,0,0,0.42)",
            py: 1.5,
            display: "flex",
            justifyContent: "center",
            opacity: hovered ? 1 : 0,
            transition: "opacity 0.3s ease",
          }}
        >
          <Typography sx={{ color: "#fff", fontSize: 11, letterSpacing: "0.14em", textTransform: "uppercase", fontWeight: 500 }}>
            View Product
          </Typography>
        </Box>
      </Box>

      {/* Name + price */}
      <Box sx={{ pt: 1.5 }}>
        <Link to={path} style={{ textDecoration: "none" }}>
          <Typography sx={{ fontSize: { xs: 13, md: 14 }, color: "#111827", fontWeight: 400, letterSpacing: "0.01em", lineHeight: 1.35 }}>
            {title}
          </Typography>
        </Link>
        <Typography sx={{ fontSize: { xs: 13, md: 14 }, color: priceColor || "#6b7280", mt: 0.5 }}>
          {price}
        </Typography>
      </Box>

      {/* Delete icon — dashboard only */}
      {pagepath.pathname.includes("dashboard") && (
        <Box sx={{ position: "absolute", top: 8, right: 8 }}>
          <DeleteIcon onClick={() => setShow(true)} />
        </Box>
      )}

      {show && (
        <DeleteConfirmModal
          item={{ name: title }}
          onClose={() => setShow(false)}
          onConfirm={handleDelete}
        />
      )}
    </Box>
  );
};
